

function authHeader() {
  const tk = localStorage.getItem('token');
  if (tk) {
    return { Authorization: `Bearer ${tk}` };
  }
  else
    return {};
}


function addBonitickAdminTocketToData(data) {
  data.bonitickAdminToken = localStorage.getItem('bonitickToken');
  return data;
}

// send a post and callback with the value of the status code (200 = OK, 401 = invalid token -> redirect to signin)
export function bonitickAuthenticatedPostFetch(url, data, callback, errorCallback) {
  const data2 = addBonitickAdminTocketToData(data);
  fetch(window.config.backend.http_route + url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data2)
    })
    .then((response) => {
      const statusCode = response.status;
      if (statusCode < 300 || statusCode === 402 || statusCode === 404) {
        const res = response.json();
        if (res.token) {
          localStorage.setItem('bonitickToken', res.token)
        }
      }
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) // (Unauthorized)
      {
        if (res >= 400 && typeof errorCallback === "function") {
          localStorage.removeItem('bonitickToken');
          errorCallback();
        }
        else if (typeof callback === "function") {
          callback(res);
        }
      }
      else {
        localStorage.removeItem('bonitickToken');
        window.location.href = "/home"
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
        localStorage.removeItem('bonitickToken');
        if (errorCallback !== undefined)
          errorCallback();
      }

    });
}

export function bonitickAuthenticatedPostFile(url, data, callback, errorCallback) {
  const data2 = addBonitickAdminTocketToData(data);
  const formData = new FormData();
  formData.append('logo', data2);
  fetch(window.config.backend.http_route + url,
    {
      method: 'POST',
      headers: {
        /* 'Content-Type': "multipart/form-data", */
        'Authorization': authHeader().Authorization
      },
      body: formData
    })
    .then((response) => {
      const statusCode = response.status;
      if (statusCode < 300 || statusCode === 402 || statusCode === 404) {
        const res = response.json();
        if (res.token) {
          localStorage.setItem('bonitickToken', res.token)
        }
      }
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res.status !== 401) // (Unauthorized)
        callback(res);
      else {
        localStorage.removeItem('bonitickToken');
        window.location.href = "/home"
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error("[" + url + "] error: ", error);
        localStorage.removeItem('bonitickToken');
        if (errorCallback !== undefined)
          errorCallback();
      }
    });
}

export function bonitickAuthenticatedPostFetchWithResult(url, data, callback, errorCallback) {
  const data2 = addBonitickAdminTocketToData(data);
  fetch(window.config.backend.http_route + url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data2)
    })
    .then(async (response) => {
      const statusCode = response.status;
      let data = undefined
      if (statusCode < 300 || statusCode === 402 || statusCode === 404) {
        data = await response.json();
        if (data.token) {
          localStorage.setItem('bonitickToken', data.token)
        }
      }
      return Promise.all([statusCode, data]);
    })
    .then((res) => {
      if (res[0] === 401) // (Unauthorized)
      {
        localStorage.removeItem('bonitickToken');
        window.location.href = "/home"
      } else {
        if (res[0] >= 400 && typeof errorCallback === "function")
          errorCallback(res[1]);
        else
          callback(res[0], res[1]);
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error("[" + url + "] error: ", error);
        if (errorCallback !== undefined)
          errorCallback();
      }
    });
}

export function bonitickAuthenticatedPutFetch(url, data, callback, errorCallback) {
  const data2 = addBonitickAdminTocketToData(data);
  fetch(window.config.backend.http_route + url,
    {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data2)
    })
    .then(async (response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) { // (Unauthorized)
        if (res >= 400) {
          localStorage.removeItem('bonitickToken');
          if (typeof errorCallback === "function") {
            errorCallback();
          }
        }
        else if (typeof callback === "function") {
          callback(res);
        }
      }
      else {
        localStorage.removeItem('bonitickToken');
        window.location.href = "/home"
      }
    })
    .catch(error => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
        if (errorCallback !== undefined)
          errorCallback();
      }

    });
}

export function bonitickAuthenticatedDeleteFetch(url, data, callback, errorCallback) {
  const data2 = addBonitickAdminTocketToData(data);
  fetch(window.config.backend.http_route + url,
    {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data2)
    })
    .then(async (response) => {
      const statusCode = response.status;
      if (statusCode < 300) {
        const res = await response.json();
        if (res.token) {
          localStorage.setItem('bonitickToken', data.token)
        }
      }
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) { // (Unauthorized)
        if (res >= 400) {
          localStorage.removeItem('bonitickToken');
          if (typeof errorCallback === "function") {
            errorCallback();
          }
        }
        else if (typeof callback === "function") {
          callback(res);
        }
      }
      else {
        localStorage.removeItem('bonitickToken');
        window.location.href = "/home"
      }
    })
    .catch(error => {
      localStorage.removeItem('bonitickToken');
      if (error.name === "AbortError") return;
      else {
        console.error(error);
        if (typeof callback === "function")
          callback(401);
      }
    });
}

export function bonitickAuthenticatedPatchFetch(url, data, callback, errorCallback) {
  const data2 = addBonitickAdminTocketToData(data);
  fetch(window.config.backend.http_route + url,
    {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
      },
      body: JSON.stringify(data2)
    })
    .then(async (response) => {
      const statusCode = response.status;
      if (statusCode < 300) {
        const res = await response.json();
        if (res.token) {
          localStorage.setItem('bonitickToken', res.token)
        }
      }
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) // (Unauthorized)
      {
        if (res >= 400) {
          localStorage.removeItem('bonitickToken');
          if (typeof errorCallback === "function") {
            errorCallback();
          }
        }
        else if (typeof callback === "function") {
          callback(res);
        }
      }
      else {
        localStorage.removeItem('bonitickToken');
        window.location.href = "/home"
      }
    })
    .catch(error => {
      console.error(error);

      if (errorCallback !== undefined)
        errorCallback();
    });
}
